export const SET_IS_LOADING_CONNECTIONS = 'SET_IS_LOADING_CONNECTIONS';
export const SET_SFTP_CONNECTIONS = 'SET_SFTP_CONNECTIONS';
export const SET_SHOPIFY_CONNECTIONS = 'SET_SHOPIFY_CONNECTIONS';